import React from "react";
import "./SightseeingOffers.css";

const SightseeingOffers = () => {
  const sightseeingOffers = [
    {
      id: 1,
      activity: "Burj Khalifa Tour",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Burj_Khalifa_logo.svg/1280px-Burj_Khalifa_logo.svg.png",
      offer: "SKY VIEW DECK",
      description: "Visit the world's tallest building",
      locations: "Dubai, UAE",
      rating: "4.8/5",
      popular: true,
    },
    {
      id: 2,
      activity: "Eiffel Tower",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Tour_Eiffel_logo.svg/1280px-Tour_Eiffel_logo.svg.png",
      offer: "SUMMIT ACCESS",
      description: "Panoramic views of Paris",
      locations: "Paris, France",
      rating: "4.7/5",
      popular: true,
    },
    {
      id: 3,
      activity: "Colosseum Tour",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Colosseo_icon.svg/1024px-Colosseo_icon.svg.png",
      offer: "GUIDED TOUR",
      description: "Ancient Roman amphitheater exploration",
      locations: "Rome, Italy",
      rating: "4.6/5",
      popular: false,
    },
    {
      id: 4,
      activity: "Grand Canyon",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Grand_Canyon_NP_logo.svg/1280px-Grand_Canyon_NP_logo.svg.png",
      offer: "HELICOPTER TOUR",
      description: "Breathtaking aerial views",
      locations: "Arizona, USA",
      rating: "4.9/5",
      popular: true,
    },
    {
      id: 5,
      activity: "Taj Mahal",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Taj_Mahal_logo.png/800px-Taj_Mahal_logo.png",
      offer: "SUNRISE TOUR",
      description: "Visit the symbol of love",
      locations: "Agra, India",
      rating: "4.8/5",
      popular: true,
    },
    {
      id: 6,
      activity: "Santorini Cruise",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Santorini_coat_of_arms.svg/800px-Santorini_coat_of_arms.svg.png",
      offer: "SUNSET CRUISE",
      description: "Volcanic islands and caldera views",
      locations: "Santorini, Greece",
      rating: "4.7/5",
      popular: false,
    },
    {
      id: 7,
      activity: "Great Wall",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Great_Wall_of_China_logo.png/800px-Great_Wall_of_China_logo.png",
      offer: "MUTIANYU SECTION",
      description: "Walk the ancient wonder",
      locations: "Beijing, China",
      rating: "4.6/5",
      popular: true,
    },
    {
      id: 8,
      activity: "Pyramids of Giza",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Giza_Plateau_logo.png/800px-Giza_Plateau_logo.png",
      offer: "CAMEL RIDE INCLUDED",
      description: "Ancient Egyptian wonders",
      locations: "Cairo, Egypt",
      rating: "4.5/5",
      popular: true,
    },
  ];

  // Fallback SVG for broken images
  const getFallbackSvg = (activityName) => {
    return `data:image/svg+xml;base64,${btoa(`
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="60" height="60" rx="12" fill="#F3F4F5"/>
        <text x="30" y="35" text-anchor="middle" fill="#676A7D" font-family="Arial, sans-serif" font-size="12">${
          activityName.split(" ")[0]
        }</text>
      </svg>
    `)}`;
  };

  const handleImageError = (e, activityName) => {
    e.target.src = getFallbackSvg(activityName);
  };

  return (
    <div className="SightseeingOffers">
      <div className="SightseeingOffers-section-header">
        <h2>🏛️ Popular Sightseeing Tours</h2>
        <p>Best activities and guided tours worldwide</p>
      </div>

      <div className="SightseeingOffers-scroll-container">
        <div className="SightseeingOffers-scroll">
          {sightseeingOffers.concat(sightseeingOffers).map((offer, index) => (
            <div
              key={`${offer.id}-${index}`}
              className="SightseeingOffers-card"
            >
              {offer.popular && (
                <div className="SightseeingOffers-popular-badge">
                  Most Popular
                </div>
              )}

              <div className="SightseeingOffers-card-header">
                <img
                  src={offer.logo}
                  alt={offer.activity}
                  className="SightseeingOffers-logo"
                  onError={(e) => handleImageError(e, offer.activity)}
                />
                <div className="SightseeingOffers-activity-info">
                  <h3>{offer.activity}</h3>
                  <div className="SightseeingOffers-rating">
                    <span className="SightseeingOffers-stars">★★★★★</span>
                    <span className="SightseeingOffers-rating-text">
                      {offer.rating}
                    </span>
                  </div>
                </div>
              </div>

              <div className="SightseeingOffers-card-body">
                <div className="SightseeingOffers-offer-main">
                  <h4>{offer.offer}</h4>
                  <p>{offer.description}</p>
                  <div className="SightseeingOffers-details">
                    <div className="SightseeingOffers-price">
                      Starting from <span>{offer.price}</span>
                    </div>
                    <div className="SightseeingOffers-duration">
                      ⏱️ {offer.duration}
                    </div>
                  </div>
                </div>

                <div className="SightseeingOffers-locations">
                  <span className="SightseeingOffers-location-icon">📍</span>
                  <span className="SightseeingOffers-location-text">
                    {offer.locations}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SightseeingOffers;
